import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import EnumField from "../ui/EnumField";
import { arrayToObject } from "../utils/Utils";

export default function POSChangeFB(props) {

    const { controller = "", route = "", callback = () => { }, invoice = "", pos_id = "", employee = "", sort = ""  } = props;

    const [loading, setLoading] = useState(false);

    const defaults = [
        { key: "from_frequent_buyer", value: "" }, 
        { key: "to_frequent_buyer", value: 0 }, 
        { key: "on_all", value: true }
    ];
    const { tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs } = useTabs(defaults, "from_frequent_buyer");

    const changeFB = (_key = "", _value = "") => {

        let _obj = arrayToObject(tabs);
        if(_obj.hasOwnProperty(_key)){
            _obj[_key] = _value; 
        }
        
        setLoading(true);

        const _params = {
            invoice: invoice,
            pos_id: pos_id,
            sort: sort,
            limit: 40,
            on_all: _obj.on_all,
            from_frequent_buyer: parseInt(_obj.from_frequent_buyer) || null,
            to_frequent_buyer: parseInt(_obj.to_frequent_buyer),
            clerk_code: employee,
        }

        pubCall("point_of_sale.setFrequentBuyerOnAllItems", _params, (_s, _r) => {
            if (_s) {
                showMessage("Frequent buyer points adjusted");
                callback(_r);
            } else {
                showError(_r);
            }
            setLoading(false);
        });
    }

    const statusus = {
        from_frequent_buyer: "Clear to update regardless of FB Reward.",
        to_frequent_buyer: "Blank will reset FB Reward to default",
        on_all: "<A>ll items or <F>rom this point on",
    };


    useEffect(() => {


        refs?.current?.[index]?.focus?.();
        refs?.current?.[index]?.select?.();
        

        const actions = [
            { key: KBD.ESCAPE, action: () => callback() },
            { key: KBD.ARROW_DOWN, action: () => next() },
            { key: KBD.ARROW_UP, action: () => prev() },
            { key: KBD.TAB, action : () => next()},
            { key: KBD.SHIFT_TAB, action : () => prev()}
        ]

        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, [index]);


    const yes_no = [
        { label: "Yes", value: true, key: KBD.Y },
        { label: "No", value: false, key: KBD.N }
    ];

    const all_from = [
        { label: "A", value: true, key: KBD.A },
        { label: "F", value: false, key: KBD.F }
    ];

    return (
        <div style={{ "width": "350px" }}>
            <Spin loading={loading}>
                <div className="shim" /><div className="shim" />
                <Space>
                    <Label width={250} >Change points from</Label>
                    <Input maxWidth={2} maxLength={2} width={35} {...editProps("from_frequent_buyer")} onEnter={(e) => { update("from_frequent_buyer", e); next(); }} onPageDown={(e) => changeFB("from_discount", e)} chars={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""]}></Input>
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >to</Label>
                    <Input maxWidth={2} maxLength={2} width={35} {...editProps("to_frequent_buyer")} onEnter={(e) => { update("to_frequent_buyer", e); next(); }} onPageDown={(e) => changeFB("to_discount", e)} chars={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ""]}></Input>
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={250} >All items from this point on?</Label>
                    <EnumField width={35} allow_empty={false} {...editProps("on_all")} onPageDown={(e) => changeFB("on_all", e)} options={all_from} />
                </Space>
                <div className="shim" /><div className="shim" />
            </Spin>
            <div className="shim" />
            <Status type="active"><InfoIcon />{statusus[index]}</Status>
        </div>
    )
}